"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePaymentMethods = exports.supportedPaymentMethods = exports.supportedPaymentGateways = exports.shouldShowGatewayComponent = exports.readablePaymentMethodNames = exports.logos = exports.getAvailablePaymentMethods = exports.default = exports.bankPaymentMethodsMapper = exports.bankPaymentMethods = exports.STANDARD_PAYMENT_METHODS = exports.BANK_PAYMENT_METHODS = void 0;
var _react = _interopRequireDefault(require("react"));
var CardLogo = function CardLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 19.893a2.388 2.388 0 0 0 2.387 2.387h23.872a2.388 2.388 0 0 0 2.387-2.387V11.14H0Zm9.549-3.382a.6.6 0 0 1 .6-.6h6.764a.6.6 0 0 1 .6.6V18.5a.6.6 0 0 1-.6.6h-6.768a.6.6 0 0 1-.6-.6Zm-6.366 0a.6.6 0 0 1 .6-.6H7.36a.6.6 0 0 1 .6.6V18.5a.6.6 0 0 1-.6.6H3.78a.6.6 0 0 1-.6-.6ZM28.646 2.387v2.387H0V2.387A2.388 2.388 0 0 1 2.387 0h23.872a2.388 2.388 0 0 1 2.387 2.387Z",
    fill: "#bcc3cd"
  }));
};
CardLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.646 22.28"
};
var PaypalLogo = function PaypalLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h25.576v30.177H0z"
  }), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h25.576v30.177H0z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m7.266 29.154.523-3.322-1.165-.027H1.061L4.927 1.292a.316.316 0 0 1 .314-.268h9.38c3.114 0 5.263.648 6.385 1.927.526.6.861 1.227 1.023 1.917.17.724.173 1.589.007 2.644l-.012.077v.676l.526.298a3.69 3.69 0 0 1 1.065.812c.45.513.741 1.165.864 1.938.127.795.085 1.741-.123 2.812-.24 1.232-.628 2.305-1.152 3.183a6.547 6.547 0 0 1-1.825 2c-.696.494-1.523.869-2.458 1.109-.906.236-1.939.355-3.072.355h-.73c-.522 0-1.029.188-1.427.525a2.21 2.21 0 0 0-.744 1.328l-.055.299-.924 5.855-.042.215c-.011.068-.03.102-.058.125a.155.155 0 0 1-.096.035H7.266Z",
    style: {
      fill: "#253b80",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.048 7.667c-.028.179-.06.362-.096.55-1.237 6.351-5.469 8.545-10.874 8.545H9.326c-.661 0-1.218.48-1.321 1.132L6.596 26.83l-.399 2.533a.704.704 0 0 0 .695.814h4.881c.578 0 1.069-.42 1.16-.99l.048-.248.919-5.832.059-.32c.09-.572.582-.992 1.16-.992h.73c4.729 0 8.431-1.92 9.513-7.476.452-2.321.218-4.259-.978-5.622a4.667 4.667 0 0 0-1.336-1.03Z",
    style: {
      fill: "#179bd7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.754 7.151a9.757 9.757 0 0 0-1.203-.267 15.284 15.284 0 0 0-2.426-.177h-7.352a1.172 1.172 0 0 0-1.159.992L8.05 17.605l-.045.289a1.336 1.336 0 0 1 1.321-1.132h2.752c5.405 0 9.637-2.195 10.874-8.545.037-.188.068-.371.096-.55a6.594 6.594 0 0 0-1.017-.429 9.045 9.045 0 0 0-.277-.087Z",
    style: {
      fill: "#222d65",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.614 7.699a1.169 1.169 0 0 1 1.159-.991h7.352c.871 0 1.684.057 2.426.177a9.757 9.757 0 0 1 1.481.353c.365.121.704.264 1.017.429.368-2.347-.003-3.945-1.272-5.392C20.378.682 17.853 0 14.622 0h-9.38c-.66 0-1.223.48-1.325 1.133L.01 25.898a.806.806 0 0 0 .795.932h5.791l1.454-9.225 1.564-9.906Z",
    style: {
      fill: "#253b80",
      fillRule: "nonzero"
    }
  }))));
};
PaypalLogo.defaultProps = {
  viewBox: "0 0 26 31",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve"
};
var ApplePayLogo = function ApplePayLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    style: {
      isolation: "isolate"
    },
    fill: "#bcc3cd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m39.031 19.574-.286-.067v-1.7h.55a1.776 1.776 0 0 0 1.94-1.33 1.993 1.993 0 0 0 .016-1.529c-1.181-3.175-2.317-6.367-3.467-9.554-.033-.093-.061-.188-.1-.306.759 0 1.5 0 2.231.009.061 0 .149.116.174.193.429 1.368.851 2.739 1.274 4.11s.838 2.711 1.258 4.066c.018.059.04.117.085.248.048-.14.078-.219.1-.3q1.256-4.054 2.509-8.109c.047-.152.1-.225.282-.222.675.013 1.35.005 2.054.005a1.762 1.762 0 0 1-.043.183q-2 5.618-4.013 11.236a6.341 6.341 0 0 1-1 1.859 3.174 3.174 0 0 1-2.229 1.162c-.075.008-.149.029-.224.045Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.531 0a3.426 3.426 0 0 1-2.41 3.554 6.35 6.35 0 0 1-.737.105 2.5 2.5 0 0 1 .142-1.272A3.529 3.529 0 0 1 9.194.043a.658.658 0 0 0 .1-.043Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.396 5.364a3.518 3.518 0 0 0 .433 6.231c-.177.409-.338.827-.535 1.227a9.013 9.013 0 0 1-1.437 2.11 2.06 2.06 0 0 1-2.608.558 3.254 3.254 0 0 0-2.029-.339 7.95 7.95 0 0 0-1.057.345 2.538 2.538 0 0 1-1.266.233 2.054 2.054 0 0 1-1.2-.67 9.773 9.773 0 0 1-2.395-4.331 7.133 7.133 0 0 1-.086-3.795 4.007 4.007 0 0 1 2.43-2.816 3.2 3.2 0 0 1 2.364-.052c.291.107.583.211.869.332a1.559 1.559 0 0 0 1.22.008 9.333 9.333 0 0 1 1.5-.5 3.611 3.611 0 0 1 3.581 1.164c.052.057.1.121.144.183.022.03.041.063.072.112Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.013 1.122c.079 0 .141-.009.2-.009 1.77 0 3.541-.009 5.311 0a4.561 4.561 0 0 1 3.579 1.551 4.722 4.722 0 0 1 1.116 3.342 4.588 4.588 0 0 1-1.508 3.461 4.8 4.8 0 0 1-3.225 1.19c-.97.019-1.941.006-2.911.007h-.312v4.941h-2.25Zm2.262 1.9v5.744h2.483c.186 0 .374 0 .558-.018a3.061 3.061 0 0 0 1.6-.566 2.689 2.689 0 0 0 1-2.277 2.561 2.561 0 0 0-1.951-2.758 3.458 3.458 0 0 0-.8-.12c-.916-.018-1.833-.014-2.749-.018a1.42 1.42 0 0 0-.138.014Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.798 15.61h-2.076v-1.688l-.087-.057a.252.252 0 0 1-.013.1 4.076 4.076 0 0 1-5.783.966 2.914 2.914 0 0 1 .538-4.849 6.933 6.933 0 0 1 2.6-.572c.829-.05 1.659-.094 2.488-.15.06 0 .165-.084.164-.127a7.5 7.5 0 0 0-.053-1.16 1.494 1.494 0 0 0-1.126-1.211 3.037 3.037 0 0 0-1.543-.08 1.839 1.839 0 0 0-1.56 1.412h-2.02A2.759 2.759 0 0 1 28.7 6.86a3.622 3.622 0 0 1 2.283-1.682 5.54 5.54 0 0 1 3.954.28 3.051 3.051 0 0 1 1.862 2.928c.01 2.346 0 4.691 0 7.037Zm-2.195-4.729a.535.535 0 0 0-.089-.009c-.751.047-1.5.092-2.253.142a3.907 3.907 0 0 0-1.448.3 1.339 1.339 0 0 0 .028 2.483 2.722 2.722 0 0 0 1.5.188 2.463 2.463 0 0 0 2.262-3.104Z"
  })));
};
ApplePayLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47.654 19.573"
};
var GooglePayLogo = function GooglePayLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    className: "st0",
    d: "M37.8 19.7V29h-3V6h7.8c1.9 0 3.7.7 5.1 2 1.4 1.2 2.1 3 2.1 4.9 0 1.9-.7 3.6-2.1 4.9-1.4 1.3-3.1 2-5.1 2l-4.8-.1zm0-10.9v8h5c1.1 0 2.2-.4 2.9-1.2 1.6-1.5 1.6-4 .1-5.5l-.1-.1c-.8-.8-1.8-1.3-2.9-1.2h-5zM56.7 12.8c2.2 0 3.9.6 5.2 1.8s1.9 2.8 1.9 4.8V29H61v-2.2h-.1c-1.2 1.8-2.9 2.7-4.9 2.7-1.7 0-3.2-.5-4.4-1.5-1.1-1-1.8-2.4-1.8-3.9 0-1.6.6-2.9 1.8-3.9 1.2-1 2.9-1.4 4.9-1.4 1.8 0 3.2.3 4.3 1v-.7c0-1-.4-2-1.2-2.6-.8-.7-1.8-1.1-2.9-1.1-1.7 0-3 .7-3.9 2.1l-2.6-1.6c1.6-2.1 3.7-3.1 6.5-3.1zm-3.8 11.4c0 .8.4 1.5 1 1.9.7.5 1.5.8 2.3.8 1.2 0 2.4-.5 3.3-1.4 1-.9 1.5-2 1.5-3.2-.9-.7-2.2-1.1-3.9-1.1-1.2 0-2.2.3-3 .9-.8.5-1.2 1.2-1.2 2.1zM80 13.3 70.1 36h-3l3.7-7.9-6.5-14.7h3.2l4.7 11.3h.1l4.6-11.3H80z",
    fill: "#5F6368"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st1",
    d: "M25.9 17.7c0-.9-.1-1.8-.2-2.7H13.2v5.1h7.1c-.3 1.6-1.2 3.1-2.6 4v3.3H22c2.5-2.3 3.9-5.7 3.9-9.7z",
    fill: "#4285F4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st2",
    d: "M13.2 30.6c3.6 0 6.6-1.2 8.8-3.2l-4.3-3.3c-1.2.8-2.7 1.3-4.5 1.3-3.4 0-6.4-2.3-7.4-5.5H1.4v3.4c2.3 4.5 6.8 7.3 11.8 7.3z",
    fill: "#34A853"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st3",
    d: "M5.8 19.9c-.6-1.6-.6-3.4 0-5.1v-3.4H1.4c-1.9 3.7-1.9 8.1 0 11.9l4.4-3.4z",
    fill: "#FBBC04"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st4",
    d: "M13.2 9.4c1.9 0 3.7.7 5.1 2l3.8-3.8c-2.4-2.2-5.6-3.5-8.8-3.4-5 0-9.6 2.8-11.8 7.3l4.4 3.4c.9-3.2 3.9-5.5 7.3-5.5z",
    fill: "#EA4335"
  }));
};
GooglePayLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 38.1"
};
var IdealLogo = function IdealLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M.39 1.935v15.363c0 .735.624 1.337 1.387 1.337h9.518c7.195 0 10.315-3.884 10.315-9.038 0-5.128-3.12-8.999-10.315-8.999H1.777C1.014.598.39 1.2.39 1.935Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.76 4.369V15.72h5.124c4.651 0 6.669-2.533 6.669-6.117 0-3.43-2.018-6.09-6.67-6.09H7.649c-.492 0-.887.388-.887.856Z",
    fill: "#C06"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.295 17.412H3.017c-.734 0-1.33-.575-1.33-1.284V3.112c0-.709.596-1.284 1.33-1.284h8.278c7.854 0 9.025 4.874 9.025 7.775 0 5.034-3.21 7.809-9.025 7.809ZM3.017 2.256c-.492 0-.887.381-.887.856v13.016c0 .475.395.856.887.856h8.278c5.531 0 8.582-2.62 8.582-7.38 0-6.392-5.38-7.348-8.582-7.348H3.017Z",
    fill: "#000"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.563 8.072c.18 0 .347.027.506.08.16.054.291.141.41.248.11.114.2.254.27.414.062.168.097.361.097.589 0 .2-.028.38-.077.548a1.265 1.265 0 0 1-.235.434c-.104.12-.236.214-.395.288-.16.067-.347.107-.562.107H7.364V8.066h1.2v.006Zm-.041 2.213c.09 0 .173-.013.263-.04a.52.52 0 0 0 .222-.14.775.775 0 0 0 .16-.254c.041-.107.062-.228.062-.381 0-.134-.014-.261-.042-.368a.72.72 0 0 0-.138-.28.623.623 0 0 0-.25-.181 1.055 1.055 0 0 0-.381-.06h-.444v1.71h.548v-.006ZM12.348 8.072v.502h-1.483v.581h1.365v.462h-1.365v.661h1.518v.502h-2.135V8.066h2.1v.006ZM14.47 8.072l1.053 2.715h-.644l-.215-.602H13.61l-.222.602h-.624l1.06-2.715h.646Zm.034 1.665-.353-.996h-.007l-.368.996h.728ZM16.528 8.072v2.213h1.373v.502h-1.99V8.072h.617Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.446 10.68c.715 0 1.296-.56 1.296-1.25 0-.691-.58-1.25-1.296-1.25-.716 0-1.297.559-1.297 1.25 0 .69.58 1.25 1.296 1.25ZM5.423 15.72c-1.088 0-1.962-.849-1.962-1.892v-1.477c0-.522.437-.95.985-.95.54 0 .984.422.984.95v3.37h-.007Z",
    fill: "#000"
  }));
};
IdealLogo.defaultProps = {
  width: "22",
  height: "19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SofortLogo = function SofortLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.83 8.662H.57L2.055 0h22.26l-1.483 8.662Z",
    fill: "#2E3235"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67 5.046c-.38 0-.647-.243-.647-.621a.81.81 0 0 1 .809-.813c.38 0 .647.254.647.632a.8.8 0 0 1-.809.802Zm.223-2.159c-1 0-1.755.717-1.755 1.574 0 .776.622 1.314 1.471 1.314 1 0 1.755-.74 1.755-1.597 0-.776-.622-1.29-1.471-1.29ZM13.69 5.046c-.381 0-.647-.243-.647-.621a.81.81 0 0 1 .808-.813c.38 0 .647.254.647.632a.8.8 0 0 1-.809.802Zm.222-2.159c-1 0-1.755.717-1.755 1.574 0 .776.622 1.314 1.471 1.314 1 0 1.756-.74 1.756-1.597 0-.776-.623-1.29-1.472-1.29ZM16.9 4.255h-.13l.098-.578h.119c.277 0 .423.081.423.259 0 .211-.208.319-.51.319Zm1.423-.456c0-.519-.416-.853-1.165-.853h-1.06l-.464 2.77h.892l.146-.872h.041l.473.871h1.023l-.656-.967c.48-.163.77-.515.77-.949ZM5.115 4.051c-.338-.167-.415-.211-.415-.3 0-.111.134-.167.322-.167.215 0 .54.023.858.32.08-.238.208-.454.376-.64-.452-.247-.867-.377-1.25-.377-.762 0-1.198.397-1.198.875 0 .411.317.626.696.815.339.17.424.223.424.327 0 .11-.142.174-.33.174-.326 0-.705-.2-.93-.404l-.13.77c.233.164.567.33 1.072.33.787 0 1.21-.385 1.21-.882 0-.404-.273-.626-.705-.841ZM11.712 4.162h-1.045l.082-.485h1.12c.145-.292.37-.542.65-.73h-1.833c-.407 0-.753.27-.814.635l-.358 2.133h.893l.146-.87h1.06l.076-.474c.004-.071.011-.14.023-.209ZM18.342 2.946c.238.179.385.428.417.73h.746l-.343 2.04h.893l.342-2.04h.827l.122-.73h-3.004Z",
    fill: "#E5E5E0"
  }));
};
SofortLogo.defaultProps = {
  width: "25",
  height: "9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BancontactLogo = function BancontactLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M.82 14.934v-3.428h1.017c.739 0 1.214.29 1.214.887 0 .337-.15.573-.362.71.306.147.484.43.484.818 0 .69-.484 1.013-1.237 1.013H.82Zm.655-2.003h.484c.297 0 .424-.151.424-.43 0-.3-.23-.397-.541-.397h-.367v.827Zm0 1.406h.404c.396 0 .626-.103.626-.426 0-.319-.197-.45-.57-.45h-.46v.876Zm2.967.656c-.645 0-.97-.328-.97-.769 0-.485.381-.769.946-.774.14.003.28.016.419.04v-.118c0-.299-.165-.44-.48-.44a1.591 1.591 0 0 0-.621.117l-.118-.529a2.25 2.25 0 0 1 .814-.147c.692 0 1.035.382 1.035 1.043v1.362c-.193.102-.555.215-1.025.215Zm.395-.553v-.524a1.516 1.516 0 0 0-.334-.04c-.217 0-.386.089-.386.319 0 .205.141.313.39.313a.712.712 0 0 0 .33-.068Zm1.087.494V12.59a2.774 2.774 0 0 1 1.064-.216c.687 0 1.082.353 1.082 1.004v1.557h-.65v-1.508c0-.338-.15-.495-.437-.495a.953.953 0 0 0-.414.089v1.914h-.645Zm4.415-2.414-.122.534a1.386 1.386 0 0 0-.532-.123c-.381 0-.588.28-.588.74 0 .504.216.764.62.764a1.29 1.29 0 0 0 .523-.128l.104.544a1.53 1.53 0 0 1-.678.142c-.78 0-1.233-.504-1.233-1.303 0-.793.447-1.317 1.195-1.317.244-.001.486.049.71.147Zm1.403 2.473c-.725 0-1.177-.524-1.177-1.312 0-.784.452-1.308 1.177-1.308.729 0 1.171.524 1.171 1.308 0 .788-.442 1.312-1.171 1.312Zm0-.558c.334 0 .508-.29.508-.754 0-.46-.174-.75-.508-.75-.33 0-.513.29-.513.75 0 .465.183.754.513.754Zm1.547.5v-2.347a2.774 2.774 0 0 1 1.063-.215c.687 0 1.082.353 1.082 1.004v1.557h-.649v-1.508c0-.338-.15-.495-.438-.495a.953.953 0 0 0-.413.089v1.914h-.645Zm3.61.058c-.56 0-.847-.318-.847-.965V12.97h-.32v-.538h.32v-.544l.65-.034v.578h.521v.538h-.522v1.048c0 .284.113.417.325.417.084 0 .167-.01.25-.03l.032.544a1.725 1.725 0 0 1-.41.044Zm1.639 0c-.645 0-.97-.328-.97-.769 0-.485.381-.769.946-.774.14.003.28.016.419.04v-.118c0-.299-.165-.44-.48-.44a1.591 1.591 0 0 0-.621.117l-.118-.529a2.25 2.25 0 0 1 .814-.147c.692 0 1.035.382 1.035 1.043v1.362c-.193.102-.555.215-1.025.215Zm.395-.553v-.524a1.517 1.517 0 0 0-.334-.04c-.217 0-.386.089-.386.319 0 .205.141.313.39.313a.712.712 0 0 0 .33-.068Zm2.852-1.92-.123.534a1.387 1.387 0 0 0-.531-.123c-.381 0-.588.28-.588.74 0 .504.216.764.62.764a1.29 1.29 0 0 0 .523-.128l.103.544a1.53 1.53 0 0 1-.677.142c-.781 0-1.233-.504-1.233-1.303 0-.793.447-1.317 1.195-1.317.244-.001.486.049.71.147Zm1.427 2.473c-.56 0-.847-.318-.847-.965V12.97h-.32v-.538h.32v-.544l.65-.034v.578h.522v.538h-.522v1.048c0 .284.113.417.324.417.084 0 .168-.01.25-.03l.033.544a1.725 1.725 0 0 1-.41.044Z",
    fill: "#1E3764"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.296 9.897c3.396 0 5.093-2.28 6.791-4.56H.821v4.56h4.475Z",
    fill: "url(#a)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.04.776c-3.477 0-5.215 2.28-6.953 4.56h11.535V.777h-4.583Z",
    fill: "url(#b)"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "a",
    x1: "3.1",
    y1: "7.827",
    x2: "11.356",
    y2: "4.783",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#005AB9"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#1E3764"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "b",
    x1: "12.786",
    y1: "5.732",
    x2: "21.714",
    y2: "2.636",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#FBA900"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#FFD800"
  }))));
};
BancontactLogo.defaultProps = {
  width: "24",
  height: "15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var supportedPaymentMethods = ['card', 'paypal', 'applepay', 'googlepay', 'ideal', 'sofort', 'bancontact_card', 'bancontact_mobile'];
exports.supportedPaymentMethods = supportedPaymentMethods;
var bankPaymentMethods = ['ideal', 'sofort',
// Sofort name in cleeng-admin
'directEbanking',
// Sofort name in Adyen
'bancontact_mobile',
// Bancontact Mobile name in cleeng-admin
'bcmc_mobile' // Bancontact Mobile name in Adyen
];

exports.bankPaymentMethods = bankPaymentMethods;
var bankPaymentMethodsMapper = {
  bcmc_mobile: 'bancontact_mobile',
  directEbanking: 'sofort',
  bcmc: 'bancontact_card'
};
exports.bankPaymentMethodsMapper = bankPaymentMethodsMapper;
var STANDARD_PAYMENT_METHODS = 'zeroPaymentSupported';
exports.STANDARD_PAYMENT_METHODS = STANDARD_PAYMENT_METHODS;
var BANK_PAYMENT_METHODS = 'zeroPaymentNotSupported';
exports.BANK_PAYMENT_METHODS = BANK_PAYMENT_METHODS;
var readablePaymentMethodNames = {
  card: 'Card',
  paypal: 'PayPal',
  applepay: 'ApplePay',
  googlepay: 'GooglePay',
  ideal: 'iDEAL',
  sofort: 'Sofort',
  bancontact_card: 'Bancontact Card',
  bancontact_mobile: 'Bancontact Mobile'
};
exports.readablePaymentMethodNames = readablePaymentMethodNames;
var supportedPaymentGateways = ['adyen', 'paypal'];
exports.supportedPaymentGateways = supportedPaymentGateways;
var logos = {
  card: CardLogo,
  paypal: PaypalLogo,
  applepay: ApplePayLogo,
  googlepay: GooglePayLogo,
  ideal: IdealLogo,
  sofort: SofortLogo,
  bancontact_card: BancontactLogo,
  bancontact_mobile: BancontactLogo
};
exports.logos = logos;
var _default = logos;
exports.default = _default;
var validatePaymentMethods = function validatePaymentMethods(paymentMethods, arePaymentMethodsProvidedByPublisher) {
  if (!paymentMethods) return [];
  return paymentMethods.filter(function (method) {
    if (supportedPaymentMethods.includes(method.methodName) && supportedPaymentGateways.includes(method.paymentGateway)) {
      return true;
    }
    if (arePaymentMethodsProvidedByPublisher) {
      // eslint-disable-next-line no-console
      console.error("Payment method not supported (id: ".concat(method.id, ")"));
    }
    return false;
  });
};
exports.validatePaymentMethods = validatePaymentMethods;
var shouldShowGatewayComponent = function shouldShowGatewayComponent(gateway, paymentMethods) {
  return !!paymentMethods.find(function (_ref) {
    var paymentGateway = _ref.paymentGateway;
    return paymentGateway === gateway;
  });
};

// returns common part between methods set in admin and those set
// by Config.setVisibleAdyenPaymentMethods()
exports.shouldShowGatewayComponent = shouldShowGatewayComponent;
var getAvailablePaymentMethods = function getAvailablePaymentMethods(publisherPaymentMethods, visiblePaymentMethods) {
  var availablePaymentMethods = visiblePaymentMethods.length ? publisherPaymentMethods.filter(function (_ref2) {
    var methodName = _ref2.methodName;
    return visiblePaymentMethods.includes(methodName);
  }) : publisherPaymentMethods;
  return availablePaymentMethods;
};
exports.getAvailablePaymentMethods = getAvailablePaymentMethods;